import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import store from "./app/store"
import { Provider } from "react-redux"
import App from './App';
import * as serviceWorker from './serviceWorker';


ReactDOM.render( <Provider store={store}><App /> </Provider>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();